module.exports = __webpack_public_path__ + "static/media/sloganEng.2011d54b.png";